import React from "react";
import { Row, Col, Input, Button, Form } from "antd";
import {
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
  YoutubeFilled,
  InstagramFilled,
  FacebookFilled,
} from "@ant-design/icons";

const ContactPage = () => {
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    console.log("Form Values:", values);
  };

  return (
    <div style={{ fontFamily: "Poppins, sans-serif", backgroundColor: "#fff" }}>
      {/* CONTACT SECTION */}
      <section style={{ padding: "60px 10%", backgroundColor: "#f9f9f9" }}>
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "16px",
            boxShadow: "0 2px 15px rgba(0,0,0,0.1)",
            overflow: "hidden",
            width: "100%",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Row gutter={0} align="stretch" style={{ width: "100%" }}>
            {/* LEFT PURPLE BOX */}
            <Col xs={24} md={10}>
              <div
                style={{
                  position: "relative",
                  background: "#3D083E",
                  color: "#fff",
                  padding: "60px 60px 60px 80px",
                  height: "100%",
                  minHeight: "480px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                {/* Big bubble (half visible in corner) */}
                <div
                  style={{
                    position: "absolute",
                    width: 300,
                    height: 300,
                    background: "#750068",
                    borderRadius: "50%",
                    bottom: -150,
                    right: -150,
                  }}
                ></div>

                {/* Small bubble overlapping */}
                <div
                  style={{
                    position: "absolute",
                    width: 140,
                    height: 140,
                    background: "rgba(72,72,72,0.5)",
                    borderRadius: "50%",
                    bottom: 50,
                    right: 70,
                  }}
                ></div>

                <h2 style={{ 
                  fontSize: "22px", 
                  fontWeight: "600", 
                  marginBottom: "20px",
                  color: "#fff"
                }}>
                  Contact Information
                </h2>
                
                <p style={{ 
                  color: "#ffffffff", 
                  marginBottom: "30px",
                  fontSize: "14px",
                  lineHeight: "1.6"
                }}>
                 Submit the form, and one of our representatives will reach out to you promptly.
                </p>

                {/* Social Icons */}
                <div style={{ 
                  marginTop: "50px", 
                  display: "flex", 
                  gap: "20px",
                  position: "relative",
                  zIndex: 2
                }}>
                  <YoutubeFilled style={{ fontSize: 22, cursor: "pointer" }} />
                  <FacebookFilled style={{ fontSize: 22, cursor: "pointer" }} />
                  <InstagramFilled style={{ fontSize: 22, cursor: "pointer" }} />
                </div>
              </div>
            </Col>

            {/* RIGHT WHITE FORM */}
            <Col xs={24} md={14}>
              <div
                style={{
                  backgroundColor: "#fff",
                  padding: "60px 50px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  height: "100%",
                  minHeight: "480px",
                }}
              >
                <Form form={form} layout="vertical" onFinish={handleSubmit}>
                  <Row gutter={16}>
                    <Col xs={24} md={12}>
                      <Form.Item label="First Name" name="firstName">
                        <Input placeholder="John" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item label="Last Name" name="lastName">
                        <Input placeholder="Doe" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={16}>
                    <Col xs={24} md={12}>
                      <Form.Item label="Email" name="email">
                        <Input placeholder="example@gmail.com" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item label="Phone Number" name="phone">
                        <Input placeholder="+012 3456 789" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item label="Message" name="message">
                    <Input.TextArea rows={4} placeholder="Write your message..." />
                  </Form.Item>

                  {/* Send Message Button aligned right */}
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{
                        backgroundColor: "#3D083E",
                        border: "none",
                        borderRadius: "8px",
                        height: "45px",
                        fontWeight: 600,
                        width: 160,
                      }}
                    >
                      Send Message
                    </Button>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;